import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kqbf429fct: FaireBrandEntity = {
  token: "b_kqbf429fct",
  type: "brand",
  name: "Fancy Concrete",
  avatarUrl:
    "https://cdn.faire.com/fastly/482c249cecfcee70faafc91e2b2bac7b70f1d51507a0bfaba6bdfd8478599eb4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8d432c08f0044b09d18e08c2fdcc7c132bf9f30fc250e2562d267b7381f80262.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/482c249cecfcee70faafc91e2b2bac7b70f1d51507a0bfaba6bdfd8478599eb4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8d432c08f0044b09d18e08c2fdcc7c132bf9f30fc250e2562d267b7381f80262.jpeg",
  location: "Indian Land, SC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 56,
  isTopShop: true,
  isInsider: true,
  description:
    "Fancy Concrete creates sculptural concrete décor designed for curated retail spaces, handcrafted in small batches with timeless forms, modern finishes, and an aesthetic customers love to collect.\n\nAt Fancy Concrete, we believe the most memorable spaces are created with objects that are both beautiful and intentional.\n\nOur collection is designed for those who appreciate modern, sculptural décor that feels timeless rather than trendy. Every piece is handcrafted in our South Carolina studio, where raw concrete is transformed into refined home accents with soft textures, organic movement, and thoughtful details.\n\nFrom statement bowls and trays to sculptural candles and decorative vessels, each design is created to bring warmth, balance, and quiet luxury to everyday living. Many of our pieces are made to evolve with your home—serving a purpose today while becoming lasting décor for years to come.\n\nBecause every item is individually handcrafted, no two pieces are exactly alike. Subtle variations in color, texture, and pattern are part of what makes each creation uniquely yours.\n\nWhether you’re styling a coffee table, creating a welcoming entryway, or searching for a meaningful gift, our goal is simple: to create timeless pieces you’ll love to display, collect, and live with every day.\n\nThank you for supporting our small business and for choosing handmade design.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:08.035Z",
    importedBy: "entity-db-cli",
  },
};
